import OrderQuantity from "@affinity/components/OrderQuantity/OrderQuantity";
import { Section } from "@affinity/components/Section";
import PlaceOrderSetQuantity from "@affinity/Handlers/PlaceOrderSetQuantity";
import { BindPrePopulate, PlaceOrderQueryModel, PopulateDelegate } from "@affinity/Store/PrePopulation";
import { CustomState } from "@affinity/Store/Reducers";
import { AffinityProduct } from "@affinity/Store/StoreTypes";
import { updateWishList } from "@insite/client-framework/Services/WishListService";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import * as React from "react";
import { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => {
    // Map required state elements to component properties
    const selectedProduct = state.affinity_place_order.selectedProduct;
    const quantityViewModel = selectedProduct === AffinityProduct.Premium
        ? state.affinity_place_order.quantityPremium
        : state.affinity_place_order.quantityRegular;
    const billToId = state.context.session.billToId!;
    const populateFunction = BindPrePopulate(state);

    return {
        quantityViewModel,
        billToId,
        populateFunction,
    };
};

const mapDispatchToProps = {
    // Map loader and setter methods to component properties
    PlaceOrderSetQuantity,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export const Step2SelectQuantity: React.FC<Props> = ({ 
    quantityViewModel,
    PlaceOrderSetQuantity,
    billToId,
    history,
    populateFunction,
}) => {

    const popSetQuantity: PopulateDelegate = function (data) {
        // Return if no data
        if (!data.quantity) {
            return undefined;
        }

        // Trim data for URL update
        const updatedQuery: PlaceOrderQueryModel = {
            ...data,
            product: undefined,
            quantity: undefined,
        }

        let quantityToSet = data.quantity;
        if (data.quantity < (quantityViewModel?.minimum ?? 0)) {
            quantityToSet = quantityViewModel?.minimum ?? quantityToSet;
        }

        if (data.quantity > (quantityViewModel?.maximum ?? 0)) {
            quantityToSet = quantityViewModel?.maximum ?? quantityToSet;
        }

        PlaceOrderSetQuantity({ quantity: quantityToSet, billToId });
        return updatedQuery;
    }

    let popResult: JSX.Element | undefined = undefined;
    useEffect(() => {
        popResult = populateFunction(popSetQuantity, history);
    }, [quantityViewModel])

    if (popResult) {
        return popResult;
    }
    
    return (
        <Section title="2. Select Quantity" shouldFocus={true}>
            <OrderQuantity
                product="Regular"
                min={quantityViewModel?.minimum ?? 0}
                max={quantityViewModel?.maximum ?? 0}
                buttonStep={500}
                sliderStep={quantityViewModel?.increment ?? 0}
                onClick={(quantity: number) => {
                    PlaceOrderSetQuantity({ quantity, billToId });
                }}
                showConfirmButton
            />
        </Section>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(Step2SelectQuantity));
